import { render, staticRenderFns } from "./ChatBotCreditDone.vue?vue&type=template&id=d62366d8&scoped=true"
import script from "./ChatBotCreditDone.vue?vue&type=script&lang=js"
export * from "./ChatBotCreditDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62366d8",
  null
  
)

export default component.exports